import React, { Component } from 'react';
import Page from '../../../containers/page';

import {
    Container,
    Row,
    Col,
    Modal, ModalHeader, ModalBody, ModalFooter, Button, Input
} from 'reactstrap';

import Isvg from 'react-inlinesvg'

import ErrorModal from '../../../components/errorModal';
import { API_ENDPOINT } from '../../../constants';
import FormGroup from 'reactstrap/lib/FormGroup';
import Label from 'reactstrap/lib/Label';
import { getHumanReadablePaymentMethod } from '../helper';


function parseText(response) {
    return response.text().then(text => {
        return {
            result: text,
            status: response.status
        }
    })
}
function parseJSON(response) {
    return response.json().then(json => {
        return {
            result: json,
            status: response.status
        }
    })
}
class MarkAsPaid extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ...props.initialData,
            form: {
            }
        };
    }
    getCurrency = () => {
        return this.props.currency ? this.props.currency : typeof window !== 'undefined' && localStorage?.getItem("currency") ? localStorage.getItem("currency") : '';
    }

    setInitialData = () => {
        const paymentData = this.state.paymentData ?? null;
        const currency = paymentData?.amount?.currency ?? this.getCurrency();
        let form = {
            paymentId: paymentData?._id ?? null,
            note: ''
        };

        this.setState({ form, currency })
    }


    get = () => {

    }
    getPaymentData = () => {
        const paymentId = this.props.isOpen?.length === 24 ? this.props.isOpen : null;
        if (paymentId) {
            fetch(API_ENDPOINT + `/api/payments/${paymentId}`, {
                method: 'GET',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                }
            }).then(res => res.json()).then((result) => {
                const payment = result ?? null;
                if (!payment || payment?.currentStatus?.status?.key !== 'UNPAID') {
                    this.onClose();
                    return;
                }
                this.setState({ paymentData: payment }, () => {
                    this.setInitialData();
                })
            })
        } else {
            this.onClose();
        }
    }

    componentDidMount() {
        this.get();
        this.getPaymentData();
    }

    componentWillUnmount() {
    }

    componentDidUpdate(prevProps, prevState) {


    }

    getGroupData = () => {
        let selectedGroupIdx = -1;
        if (this.props.uData && this.props.selectedGroup && this.props.uData?.clinicGroups?.length) {
            for (let i = 0; i < this.props.uData.clinicGroups.length; i++) {
                if (this.props.uData.clinicGroups[i]._id == this.props.selectedGroup) {
                    selectedGroupIdx = i;
                    break;
                }
            }
        }
        const groupData = selectedGroupIdx > -1 ? this.props.uData?.clinicGroups?.[selectedGroupIdx] : null;
        return groupData;
    }
    onClose = (callback) => {
        if (this.props.onClose) {
            this.props.onClose(callback);
        }
    }




    sendRequest = () => {
        const errors = this.checkValidation();
        if (errors) {
            this.setState({ errors: errors })
            return;
        }
        const form = this.state.form;
        const paymentData = this.state.paymentData;
        const paymentId = paymentData?._id;
        if (!paymentId) {
            return;
        }

        const data = {
            note: form.note
        }

        this.setState({ loadingUpdate: true }, () => {
            fetch(API_ENDPOINT + `/api/payments/mark-as-paid/${paymentId}`, {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(data)
            }).then(parseJSON).then(({ result, status }) => {
                this.setState({ loadingUpdate: false }, () => {
                    if (result?.error) {
                        this.setState({ error: result?.error })
                    } else if (result?.success) {
                        this.onClose();
                    }
                })
            })
        })


    }

    checkValidation = () => {
        const form = this.state.form;
        let errors = {};
        // if (!form?.note || !form?.note.trim()) {
        //     errors.note = 'Note is required'.translate(this.props.lang);
        // }

        return Object.keys(errors).length ? errors : null;
    }

    render() {
        const isOpen = this.props.isOpen;
        const paymentData = this.state.paymentData;

        if (!paymentData) {
            return null;
        }

        const errors = this.state.errors ?? {};

        return (
            <>
                <Modal isOpen={isOpen} centered className='create-payment-modal-wrap'>
                    {/* <ModalHeader
                        toggle={() => this.onClose()}
                        close={
                            <button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.onClose()}>&times;</button>
                        }
                    >
                        {'Mark as paid'.translate(this.props.lang)}
                    </ModalHeader> */}

                    <ModalBody className='create-payment-modal-body'>
                        <Row>
                            <Col lg="12">
                                <div style={{ textAlign: 'center', marginTop: 30, marginBottom: 30 }}>
                                    {'Are you sure you want to mark this case as paid?'.translate(this.props.lang)}
                                </div>
                            </Col>
                            <Col lg="12">
                                <Input
                                    type="textarea"
                                    placeholder={'Enter note (optional)'.translate(this.props.lang)}
                                    style={{ height: 100 }}
                                    value={this.state.form?.note}
                                    onChange={(e) => {
                                        let value = e.target.value;
                                        let form = this.state.form;
                                        form.note = value;
                                        this.setState({ form });
                                    }}
                                />
                            </Col>

                        </Row>





                    </ModalBody>
                    <ModalFooter className='modal-footer-buttons-wrap' style={{ justifyContent: 'center' }}>
                        <Button
                            color="primary"
                            onClick={() => this.sendRequest()}
                            disabled={this.state.loadingUpdate}
                            style={{ minWidth: 100 }}
                        >
                            {'Yes'.translate(this.props.lang)}
                        </Button>
                        <Button style={{ minWidth: 100 }} color="primary" className='red-button' onClick={() => this.onClose()}>{'Cancel'.translate(this.props.lang)}</Button>

                    </ModalFooter>
                </Modal>

                {this.state.error ?

                    <ErrorModal lang={this.props.lang}
                        isOpen={this.state.error}
                        toggle={() => this.setState({ error: null })}

                    >
                        {this.state.error.translate(this.props.lang)}
                    </ErrorModal>

                    : null}

            </>
        );
    }
}


export default MarkAsPaid;